import React, {useState} from "react";
import ActionsComponent from "../components/ActionsComponent";
import {TextField} from "@mui/material";
import {replaceSpecialCodes} from "../utils/utils";
import globalVars from "../utils/globalVars";

export default function ResearchComponent(props) {
    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        setShowSolution(!showSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        setShowFeedback(!showFeedback)
    }

    return (
        <div key={props.index}>
            <TextField
                aria-label="minimum height"
                multiline
                maxRows={5}
                placeholder=""
                style={{
                    width: "60vw",
                }}
            />
            <ActionsComponent
                onToggleShowSolution={handleShowSolution}
                onToggleShowFeedback={handleShowFeedback}
                {...props}
            />
            {(showSolution) &&
                <p key={"answer" + props.index}><i
                    style={{
                        color: '#666',
                        backgroundColor: globalVars.solutionMode.on
                    }}>Geben Sie Ihre Recherche in das Feld ein.</i></p>}
        </div>
    );
}
